var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-c-status" }, [
    _c("div", { staticClass: "status" }, [
      _vm.arrowType === "light"
        ? _c(
            "div",
            { staticClass: "status-active", on: { click: _vm.handleSelete } },
            [
              _vm._v(" " + _vm._s(_vm.activeStatu) + " "),
              _c("img", {
                class: { activeImg: _vm.show },
                attrs: {
                  src: require("@/assets/packageAssets/common/arrow06.png"),
                  alt: "",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.arrowType === "deep"
        ? _c(
            "div",
            { staticClass: "status-active", on: { click: _vm.handleSelete } },
            [
              _vm._v(" " + _vm._s(_vm.activeStatu) + " "),
              _c("img", {
                class: { activeImg: _vm.show },
                attrs: {
                  src: require("@/assets/packageAssets/common/arrow07.png"),
                  alt: "",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.show
        ? _c(
            "div",
            { staticClass: "status-list" },
            _vm._l(_vm.statuslist, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(item.text, item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }